import { jsx as e } from "react/jsx-runtime";
import { Button as n } from "@chakra-ui/react";
function p({ isPressed: t = !1, children: o, ...r }) {
  return /* @__PURE__ */ e(n, { "aria-pressed": t, type: "button", variant: "toggle", ...r, children: o });
}
export {
  p as ToggleButton
};
